import {DEV, PRO, SANDBOX } from "../Constants/PathConstant.js"

export var EVN = {
  DEV:'development',
  PRO: 'production',
  SANDBOX: 'sandbox',
}
export var UserParameter = {data:{}}
export default function Environment(evn) {
  switch(evn) {
    case EVN.DEV : return DEV
    case EVN.SANDBOX : return SANDBOX
    case EVN.PRO : return PRO
    default : return DEV
  }
}

export var ImageConfig = {
  signedUrl:'',
  mime:'', 
  blob_body:''
}